"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SET_PROFILE_IMAGE_DATA_UPLOAD_FAILED = exports.SET_PROFILE_IMAGE_FAILED = exports.SET_PROFILE_IMAGE_SUCCEEDED = exports.SET_PROFILE_IMAGE_REQUESTED = void 0;
const uuid_1 = require("uuid");
const CachingDataService_1 = __importStar(require("../../services/data/CachingDataService"));
const service_1 = __importDefault(require("../../services/userMgmt/service"));
const setProfileImage_1 = require("../../services/userMgmt/setProfileImage");
const blobFunctions_1 = require("../../utils/blobFunctions");
exports.SET_PROFILE_IMAGE_REQUESTED = "SET_PROFILE_IMAGE_REQUESTED";
exports.SET_PROFILE_IMAGE_SUCCEEDED = "SET_PROFILE_IMAGE_SUCCEEDED";
exports.SET_PROFILE_IMAGE_FAILED = "SET_PROFILE_IMAGE_FAILED";
exports.SET_PROFILE_IMAGE_DATA_UPLOAD_FAILED = "SET_PROFILE_IMAGE_DATA_UPLOAD_FAILED";
function default_1(userId, data) {
    return (dispatch) => __awaiter(this, void 0, void 0, function* () {
        const imageId = uuid_1.v1().toString();
        // Start uploading the image data
        let putDataTask = CachingDataService_1.default.putData(CachingDataService_1.DataSource.Avatar, imageId, data, true);
        const blobUrl = blobFunctions_1.dataToBlobUrl(data, null);
        // Dispatch the set profile image requested event - this will set the imageBlobUrl on "my profile" which will render the avatar image
        const requestEvent = {
            type: exports.SET_PROFILE_IMAGE_REQUESTED,
            payload: {
                userId,
                imageId,
                blobUrl
            }
        };
        dispatch(requestEvent);
        // Wait for the media data to finish uploading
        const succeeded = yield putDataTask;
        if (!succeeded) {
            const outcomeEvent = {
                type: exports.SET_PROFILE_IMAGE_DATA_UPLOAD_FAILED,
                payload: {
                    userId,
                    imageId,
                }
            };
            dispatch(outcomeEvent);
            return;
        }
        // Set the imageId against the user profile on the IC
        const response = yield service_1.default.setProfileImage(imageId);
        let outcomeEvent;
        if (response === setProfileImage_1.SetProfileImageResponse.Success) {
            outcomeEvent = {
                type: exports.SET_PROFILE_IMAGE_SUCCEEDED,
                payload: {
                    userId,
                    imageId,
                    blobUrl
                }
            };
        }
        else {
            outcomeEvent = {
                type: exports.SET_PROFILE_IMAGE_FAILED,
                payload: {
                    userId,
                    imageId,
                }
            };
        }
        dispatch(outcomeEvent);
        return outcomeEvent;
    });
}
exports.default = default_1;
